var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1167.64 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Final") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M494.15,736.44h-16.8v31.11a90.92,90.92,0,0,0-19.42,0,90.5,90.5,0,0,0-73,53.54,89.22,89.22,0,0,0-6,19.42H234.71L364,821.09A109.93,109.93,0,0,1,457.93,748v-11.6H441.12a9.71,9.71,0,0,1-9.71-9.71h0a9.71,9.71,0,0,1,9.71-9.71h53a9.71,9.71,0,0,1,9.71,9.71h0A9.71,9.71,0,0,1,494.15,736.44Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.48,749.73l-27,20.48a9.71,9.71,0,0,1-13.6-1.86h0a9.71,9.71,0,0,1,1.86-13.61l27-20.47a9.71,9.71,0,1,1,11.74,15.46Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.93,874.13a89,89,0,0,0,6,19.41,90.27,90.27,0,1,0,155.86-89.06l-15.28,17.85-15.84-44.89-5.83-16.51,23.6,4.4,40.41,7.53-14.11,16.49A109.71,109.71,0,1,1,364,893.54L234.71,874.13H378.93Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.74,848.92c-.25,2.76-.39,5.56-.39,8.4s.14,5.63.39,8.4l-19.56-1.15-123.47-7.25,123.47-7.25Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.45,849.64c-11,10.8-25.09,15.81-40.45,15.81-39.54,0-56.26-27.22-56.42-54.89-.15-27.83,17.95-56.11,56.42-56.11a54.91,54.91,0,0,1,39.08,16.27L743.7,783.64a36.6,36.6,0,0,0-25.7-10c-25.7,0-36.8,19.16-36.65,36.95s10.34,36,36.65,36c9.27,0,19.77-3.8,26.76-10.8Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.52,810.41c-.31,27.52-17.18,55-54.59,55s-54.74-26.91-54.74-54.89,17.94-56.11,54.74-56.11S889.82,782.58,889.52,810.41Zm-89.57.45c.46,17.49,9.89,36.19,35,36.19s34.52-18.85,34.82-36.34c.3-17.94-9.73-38-34.82-38S799.5,792.92,800,810.86Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.76,774.82H907V756.58h87.59v18.24H960.83V863H940.76Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.11,863V756.58H1042V863Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.42,756.58h81.81V766L1101,844h55.2v19h-83.18V851.46l54-76h-52.61Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.17,843h-55.65L1194.39,863h-21.74l47.74-106.44h21.9L1290,863h-21.9Zm-27.83-64-19.77,45.31h39.54Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1362.87,831.7h-30.11V863h-20.07V756.58c16.73,0,33.46-.16,50.18-.16C1414.88,756.42,1415,831.7,1362.87,831.7Zm-30.11-18.4h30.11c25.7,0,25.55-37.72,0-37.72h-30.11Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.8,923.84a20.76,20.76,0,0,1-14.88,5.75c-14.54,0-20.7-9.9-20.75-20s6.6-20.42,20.75-20.42a20.29,20.29,0,0,1,14.37,5.92l-4.92,4.7a13.52,13.52,0,0,0-9.45-3.65c-9.45,0-13.54,7-13.48,13.45s3.8,13.12,13.48,13.12a14.47,14.47,0,0,0,9.84-3.93Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.85,909.56c-.11,10-6.32,20-20.08,20s-20.13-9.79-20.13-20,6.6-20.42,20.13-20.42S772,899.43,771.85,909.56Zm-32.94.16c.17,6.37,3.63,13.18,12.86,13.18s12.7-6.87,12.81-13.23c.12-6.53-3.58-13.84-12.81-13.84S738.74,903.19,738.91,909.72Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.55,896.6H805.13V890h32.22v6.64H824.93v32.11h-7.38Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.32,928.71V890h7.32v38.75Zm12.58-50.15h-8l-4.14,7.53v.33h6l6.15-7.58Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.4,890h30.09v3.43l-20.3,28.4h20.3v6.92H919.9V924.5l19.85-27.67H920.4Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.21,921.4H994.73l-3.35,7.31h-8L1000.94,890H1009l17.56,38.75h-8ZM1005,898.1l-7.27,16.49h14.54Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.29,890v32h20.14v6.75h-27.52V890Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.38,909.56c-.11,10-6.32,20-20.08,20s-20.14-9.79-20.14-20,6.6-20.42,20.14-20.42S1165.49,899.43,1165.38,909.56Zm-33,.16c.17,6.37,3.64,13.18,12.87,13.18s12.69-6.87,12.81-13.23c.11-6.53-3.58-13.84-12.81-13.84S1132.26,903.19,1132.43,909.72Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.48,906l10.4-16h8.89v.33l-15.6,22.42v16h-7.38v-16l-15-22.42V890h8.78Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.25,921.4h-20.47l-3.36,7.31h-8L1332,890h8l17.57,38.75h-8.06ZM1336,898.1l-7.27,16.49h14.54Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.35,924.72c0,5.82-8.95,5.82-8.95,0S1402.35,918.86,1402.35,924.72Zm-.84-34.7v28.56h-7.33V890Z",
    transform: "translate(-234.71 -717.02)",
    style: {
      fill: "#22205f"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.c1f7ba4f88dc61378012e4a7ae18253d.svg";
export { ForwardRef as ReactComponent };